<template>
  <div class="blk_feature" :class="{bg_photo : bg}">
    <div v-if="imgName" class="feature_photo"><img :src="imgSrc" alt=""></div>

    <h2 class="feature_title h_deco h_feature " :class="[titlePos ? 'pos_r' : 'pos_l', imgName == 'contact' ? 'contact' : '']">{{ upperTitle() }}</h2>
    <p class="feature_summary" :class="{vartical: vartical}" v-html="copy"></p>
    <p v-if="imgName != 'about'" class="feature_txt" v-html="text"></p>
    <FeatureFacilities v-if="bg && imgName == 'about'" :lists="lists"/>
    <PictureFrame v-if="bg && imgName == 'gallary'" :path="'home/gallary/img_gallary_0'" :repeat="5"/>
  </div>
</template>

<script>
// molcules
import PictureFrame from '../molcules/pictureFrame.vue'

// organisms
import FeatureFacilities from './featureFacilities.vue'

export default {
  name: 'Feature',
  components: {
    PictureFrame,
    FeatureFacilities
  },
  props: {
    msg: String,
    bg: {
      type: Boolean,
      default: false
    },
    imgName: String,
    vartical: {
      type: Boolean,
      default: false
    },
    title: String,
    titlePos: {
      type: Boolean,
      default: true
    },
    copy: String,
    text: String,
    lists: Array
  },
  data () {
    return {
      imgSrc: `/assets/img/home/img_${this.imgName}.png`
    }
  },
  methods: {
    upperTitle: function(){
      return String(this.title).toUpperCase()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
